import WhatsappOverview from './pages/whatsapp/WhatsappOverview';
import MarketingApps from './pages/marketing/MarketingApps';
import WhatsappCatalog from './pages/whatsapp/WhatsappCatalog';
import WhatsappStatusAds from './pages/whatsapp/WhatsappStatusAds';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { SettingsShell } from '@/components/settings/SettingsShell';
import ProfileSettings from '@/pages/settings/ProfileSettings';
import SettingsHub from '@/pages/settings/SettingsHub';
import TeamSettings from '@/pages/settings/TeamSettings';
import DepartmentsSettings from '@/pages/settings/DepartmentsSettings';
import AiSettings from '@/pages/settings/AiSettings';
import PlanSettings from '@/pages/settings/PlanSettings';
import IntegrationsSettings from '@/pages/settings/IntegrationsSettings';
import ActivitySettings from '@/pages/settings/ActivitySettings';
import CustomFieldsSettings from '@/pages/settings/CustomFieldsSettings';
import PipelinesSettings from '@/pages/settings/PipelinesSettings';
import LeadAdFormsSettings from '@/pages/settings/LeadAdFormsSettings';
import EmailInboxesSettings from '@/pages/settings/EmailInboxesSettings';
import CrmSyncSettings from '@/pages/settings/CrmSyncSettings';
import BusinessProfileSettings from '@/pages/settings/BusinessProfileSettings';
import LocalizationSettings from '@/pages/settings/LocalizationSettings';
import BookingSiteSettings from '@/pages/settings/BookingSiteSettings';
import IndustryPagesSettings from '@/pages/settings/IndustryPagesSettings';
import WebFormsList from '@/pages/web-forms/WebFormsList';
import WebFormBuilder from '@/pages/web-forms/WebFormBuilder';
import PublicForm from '@/pages/web-forms/PublicForm';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import Login from '@/pages/Login';
import Forbidden from '@/pages/Forbidden';
import SubscriptionBlocked from '@/pages/SubscriptionBlocked';
import Onboarding from '@/pages/Onboarding';
import Chats from '@/pages/Chats';
import DocumentsList from '@/pages/documents/DocumentsList';
import DocumentEditor from '@/pages/documents/DocumentEditor';
import CalendarPage from '@/pages/Calendar';
import TiktokAccount from '@/pages/tiktok/TiktokAccount';
import TiktokWorkspace from '@/pages/tiktok/TiktokWorkspace';
import TiktokHub from '@/pages/tiktok/TiktokHub';
import TiktokAdsManager from '@/pages/tiktok/TiktokAdsManager';
import TiktokToolsManager from '@/pages/tiktok/TiktokToolsManager';
import TiktokWizard from '@/pages/tiktok/TiktokWizard';
import XAdsAccountPage from '@/pages/x-ads/XAdsAccount';
import XAdsCampaigns from '@/pages/x-ads/XAdsCampaigns';
import XAdsCampaignWizard from '@/pages/x-ads/XAdsCampaignWizard';
import XAdsCreatives from '@/pages/x-ads/XAdsCreatives';
import XAdsTools from '@/pages/x-ads/XAdsTools';
import XAdsReporting from '@/pages/x-ads/XAdsReporting';
import GoogleAdsAccountPage from '@/pages/google-ads/GoogleAdsAccount';
import GoogleAdsCampaigns from '@/pages/google-ads/GoogleAdsCampaigns';
import GoogleAdsToolsManager from '@/pages/google-ads/GoogleAdsToolsManager';
import GoogleAdsObjectivePicker from '@/pages/google-ads/GoogleAdsObjectivePicker';
import GoogleAdsCampaignWizard from '@/pages/google-ads/GoogleAdsCampaignWizard';
import YouTubeAdsPage from '@/pages/google-ads/youtube/YouTubeAdsPage';
import YouTubeCallback from '@/pages/google-ads/youtube/YouTubeCallback';
import YouTubeObjectivePicker from '@/pages/google-ads/youtube/YouTubeObjectivePicker';
import YouTubeCampaignWizard from '@/pages/google-ads/youtube/YouTubeCampaignWizard';
import CreateYouTubeAdgroup from '@/pages/google-ads/youtube/CreateYouTubeAdgroup';
import CreateYouTubeAd from '@/pages/google-ads/youtube/CreateYouTubeAd';
import AppPromotionPage from '@/pages/google-ads/app-promotion/AppPromotionPage';
import AppPromotionWizard from '@/pages/google-ads/app-promotion/AppPromotionWizard';
// One folder per Google Ads objective — workspace list + campaign / ad group / ad pages.
import LeadsPage from '@/pages/google-ads/leads/LeadsPage';
import LeadsCampaignWizard from '@/pages/google-ads/leads/LeadsCampaignWizard';
import CreateLeadsAdgroup from '@/pages/google-ads/leads/CreateLeadsAdgroup';
import CreateLeadsAd from '@/pages/google-ads/leads/CreateLeadsAd';
import TrafficPage from '@/pages/google-ads/traffic/TrafficPage';
import TrafficCampaignWizard from '@/pages/google-ads/traffic/TrafficCampaignWizard';
import CreateTrafficAdgroup from '@/pages/google-ads/traffic/CreateTrafficAdgroup';
import CreateTrafficAd from '@/pages/google-ads/traffic/CreateTrafficAd';
import AwarenessPage from '@/pages/google-ads/awareness/AwarenessPage';
import AwarenessCampaignWizard from '@/pages/google-ads/awareness/AwarenessCampaignWizard';
import CreateAwarenessAdgroup from '@/pages/google-ads/awareness/CreateAwarenessAdgroup';
import CreateAwarenessAd from '@/pages/google-ads/awareness/CreateAwarenessAd';
import SalesPage from '@/pages/google-ads/sales/SalesPage';
import SalesCampaignWizard from '@/pages/google-ads/sales/SalesCampaignWizard';
import CreateSalesAssetGroup from '@/pages/google-ads/sales/CreateSalesAssetGroup';
import LocalPage from '@/pages/google-ads/local/LocalPage';
import LocalCampaignWizard from '@/pages/google-ads/local/LocalCampaignWizard';
import CreateLocalAssetGroup from '@/pages/google-ads/local/CreateLocalAssetGroup';
import ShoppingPage from '@/pages/google-ads/shopping/ShoppingPage';
import ShoppingCampaignWizard from '@/pages/google-ads/shopping/ShoppingCampaignWizard';
import CreateShoppingAdgroup from '@/pages/google-ads/shopping/CreateShoppingAdgroup';
import CreateShoppingAd from '@/pages/google-ads/shopping/CreateShoppingAd';
import DealsPage from '@/pages/deals/Deals';
import TablesPage from '@/pages/tables/Tables';
import TicketsList from '@/pages/tickets/TicketsList';
import TicketDetail from '@/pages/tickets/TicketDetail';
import ProjectsList from '@/pages/projects/ProjectsList';
import ProjectDetail from '@/pages/projects/ProjectDetail';
import RetainersPage from '@/pages/retainers/Retainers';
import CatalogPage from '@/pages/catalog/Catalog';
import OrdersPage from '@/pages/orders/Orders';
import OrderComposer from '@/pages/orders/OrderComposer';
import StaffShifts from '@/pages/staff/StaffShifts';
import StockPage from '@/pages/stock/Stock';
import PropertiesPage from '@/pages/real-estate/Properties';
import PropertyDetail from '@/pages/real-estate/PropertyDetail';
import ViewingsPage from '@/pages/real-estate/Viewings';
import LeasesPage from '@/pages/real-estate/Leases';
import OwnersTenantsPage from '@/pages/real-estate/OwnersTenants';
import TasksPage from '@/pages/Tasks';
import NotFound from '@/pages/NotFound';
import Dashboard from '@/pages/Dashboard';
import Reports from '@/pages/Reports';
import AdsOverview from '@/pages/AdsOverview';
import AdRules from '@/pages/AdRules';
import AdsCompare from '@/pages/AdsCompare';
import Workflows from '@/pages/Workflows';
import LeadsInbox from '@/pages/leads/LeadsInbox';
import LeadDetail from '@/pages/leads/LeadDetail';
import LeadsAnalytics from '@/pages/leads/LeadsAnalytics';
import AiAnalytics from '@/pages/leads/AiAnalytics';
import AiConversationReview from '@/pages/leads/AiConversationReview';
import BotFlowsList from '@/pages/leads/BotFlowsList';
import BotFlowDetail from '@/pages/leads/BotFlowDetail';
import BotFlowWizard from '@/pages/leads/BotFlowWizard';
import ContactsList from '@/pages/contacts/ContactsList';
import ContactCreate from '@/pages/contacts/ContactCreate';
import ContactDetail from '@/pages/contacts/ContactDetail';
import ContactImport from '@/pages/contacts/ContactImport';
import GroupsList from '@/pages/groups/GroupsList';
import GroupForm from '@/pages/groups/GroupForm';
import GroupMembers from '@/pages/groups/GroupMembers';
import WhatsappAccountsManager from '@/pages/whatsapp-account/WhatsappAccountsManager';
import WhatsappToolsManager from '@/pages/whatsapp-bulk/WhatsappToolsManager';
import TemplatesList from '@/pages/templates/TemplatesList';
import TemplateEditor from '@/pages/templates/TemplateEditor';
import CampaignsList from '@/pages/campaigns/CampaignsList';
import CampaignBuilder from '@/pages/campaigns/CampaignBuilder';
import CampaignDetail from '@/pages/campaigns/CampaignDetail';
import FacebookAccountsManager from '@/pages/facebook/FacebookAccountsManager';
import FacebookCampaignsList from '@/pages/facebook/CampaignsList';
import FacebookCampaignDetail from '@/pages/facebook/CampaignDetail';
import FacebookCampaignBuilder from '@/pages/facebook/CampaignBuilder';
import AdSetBuilder from '@/pages/facebook/AdSetBuilder';
import AdSetDetail from '@/pages/facebook/AdSetDetail';
import AdBuilder from '@/pages/facebook/AdBuilder';
import CreativesList from '@/pages/facebook/CreativesList';
import CreativeBuilder from '@/pages/facebook/CreativeBuilder';
import AudiencesList from '@/pages/facebook/AudiencesList';
import LeadFormsList from '@/pages/facebook/LeadFormsList';
import LeadFormBuilder from '@/pages/facebook/LeadFormBuilder';
import LeadFormDetail from '@/pages/facebook/LeadFormDetail';
import InstagramOverview from '@/pages/facebook/InstagramOverview';
import InstagramPublish from '@/pages/facebook/InstagramPublish';
import InstagramPosts from '@/pages/instagram/InstagramPosts';
import InstagramCampaignsList from '@/pages/instagram/InstagramCampaignsList';
import IgWorkspace from '@/pages/instagram/IgWorkspace';
import FbWorkspace from '@/pages/facebook/FbWorkspace';
import FacebookPageManager from '@/pages/facebook/FacebookPageManager';
import AiCampaignWizard from '@/pages/facebook/AiCampaignWizard';
import CustomObjectTypesList from '@/pages/custom-objects/CustomObjectTypesList';
import CustomObjectTypeEditor from '@/pages/custom-objects/CustomObjectTypeEditor';
import CustomObjectRecordsList from '@/pages/custom-objects/CustomObjectRecordsList';
import CustomObjectRecordEditor from '@/pages/custom-objects/CustomObjectRecordEditor';
import CustomObjectExamples from '@/pages/custom-objects/CustomObjectExamples';
import EmailSequences from '@/pages/EmailSequences';
import ContactDuplicates from '@/pages/ContactDuplicates';
import PublicBooking from '@/pages/PublicBooking';
import AppointmentCalendar from '@/pages/appointments/AppointmentCalendar';
import ApptServicesPage from '@/pages/appointments/AppointmentServices';
import ServiceEditorPage from '@/pages/appointments/ServiceEditor';
import ServiceViewPage from '@/pages/appointments/ServiceView';
import ApptBookingsPage from '@/pages/appointments/AppointmentBookings';
import DeveloperSettings from '@/pages/settings/DeveloperSettings';
import ProductsPage from '@/pages/products/ProductsPage';
import ProductDetailPage from '@/pages/products/ProductDetailPage';
import AiStudio from '@/pages/ai-studio/AiStudio';
import MediaLibrary from '@/pages/MediaLibrary';
import BroadcastsList from '@/pages/whatsapp-bulk/BroadcastsList';
import BroadcastComposer from '@/pages/whatsapp-bulk/BroadcastComposer';
import BroadcastDetail from '@/pages/whatsapp-bulk/BroadcastDetail';

// ── Route wrappers — force a fresh component instance per navigation. ─────────
// React Router reuses component instances when path patterns match (e.g. user
// creates ad #1 → navigates back → opens "+ Ad" again on the same adset).
// Keying on `useLocation().key` re-mounts the builder so `useState('')` initial
// values run fresh. Only applied to /new (builder) routes, not list/detail.
function CampaignBuilderRoute() {
  const loc = useLocation();
  return <FacebookCampaignBuilder key={loc.key} />;
}
function AdSetBuilderRoute() {
  const loc = useLocation();
  return <AdSetBuilder key={loc.key} />;
}
function AdBuilderRoute() {
  const loc = useLocation();
  return <AdBuilder key={loc.key} />;
}
function CreativeBuilderRoute() {
  const loc = useLocation();
  return <CreativeBuilder key={loc.key} />;
}
function BroadcastComposerRoute() {
  const loc = useLocation();
  return <BroadcastComposer key={loc.key} />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/403" element={<Forbidden />} />
      <Route path="/subscription-blocked" element={<SubscriptionBlocked />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

      {/* Public form renderer — no auth, no layout */}
      <Route path="/embed/forms/:formUid" element={<PublicForm />} />
      <Route path="/book/:slug" element={<PublicBooking />} />

      {/* Standard app layout */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        {/* Workspaces live INSIDE the layout like TikTok's — the global
            sidebar auto-collapses on any /…workspace… URL instead of
            disappearing entirely (it looked broken with no nav at all). */}
        <Route path="/facebook/workspace" element={<FbWorkspace />} />
        <Route path="/facebook/workspace/:draftId" element={<FbWorkspace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/ads-overview" element={<AdsOverview />} />
        <Route path="/marketing/apps" element={<MarketingApps />} />
        <Route path="/marketing/apps/:appUid" element={<MarketingApps />} />
        <Route path="/ad-rules" element={<AdRules />} />
        <Route path="/ads-compare" element={<AdsCompare />} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/contacts" element={<ContactsList />} />
        <Route path="/contacts/new" element={<ContactCreate />} />
        <Route path="/contacts/import" element={<ContactImport />} />
        <Route path="/contacts/:uid" element={<ContactDetail />} />
        <Route path="/groups" element={<GroupsList />} />
        <Route path="/groups/new" element={<GroupForm />} />
        <Route path="/groups/:uid" element={<GroupForm />} />
        <Route path="/groups/:uid/members" element={<GroupMembers />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/documents" element={<DocumentsList />} />
        <Route path="/documents/:uid" element={<DocumentEditor />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/tiktok" element={<TiktokHub />} />
        <Route path="/tiktok/workspace" element={<TiktokWorkspace />} />
        <Route path="/tiktok/workspace/:draftId" element={<TiktokWorkspace />} />
        <Route path="/tiktok/account" element={<TiktokAccount />} />
        <Route path="/tiktok/campaigns/new-wizard" element={<TiktokWizard />} />
        <Route path="/tiktok/campaigns" element={<TiktokAdsManager />} />
        {/* Consolidated into the tabbed Ads Manager — keep old links working. */}
        <Route path="/tiktok/ad-groups" element={<Navigate to="/tiktok/campaigns?tab=adgroups" replace />} />
        <Route path="/tiktok/ads" element={<Navigate to="/tiktok/campaigns?tab=ads" replace />} />
        {/* Merged into the tabbed Measurement page — old links still resolve. */}
        <Route path="/tiktok/measurement" element={<TiktokToolsManager />} />
        <Route path="/tiktok/reporting" element={<Navigate to="/tiktok/measurement?tab=reporting" replace />} />
        <Route path="/tiktok/pixel" element={<Navigate to="/tiktok/measurement?tab=pixel" replace />} />
        <Route path="/tiktok/audiences" element={<Navigate to="/tiktok/measurement?tab=audiences" replace />} />
        <Route path="/tiktok/event-rules" element={<Navigate to="/tiktok/measurement?tab=event-rules" replace />} />
        <Route path="/tiktok/lead-forms" element={<Navigate to="/tiktok/measurement?tab=lead-forms" replace />} />
        <Route path="/x-ads" element={<Navigate to="/x-ads/campaigns" replace />} />
        <Route path="/x-ads/campaigns" element={<XAdsCampaigns />} />
        <Route path="/x-ads/campaigns/new" element={<XAdsCampaignWizard />} />
        <Route path="/x-ads/creatives" element={<XAdsCreatives />} />
        <Route path="/x-ads/tools" element={<XAdsTools />} />
        <Route path="/x-ads/reporting" element={<XAdsReporting />} />
        <Route path="/x-ads/account" element={<XAdsAccountPage />} />
        <Route path="/google-ads" element={<Navigate to="/google-ads/campaigns" replace />} />
        <Route path="/google-ads/account" element={<GoogleAdsAccountPage />} />
        {/* More specific routes first — /new and /objective must not be
            swallowed by the campaigns list route. */}
        <Route path="/google-ads/campaigns/objective" element={<GoogleAdsObjectivePicker />} />
        <Route path="/google-ads/campaigns/new" element={<GoogleAdsCampaignWizard />} />
        <Route path="/google-ads/campaigns" element={<GoogleAdsCampaigns />} />
        <Route path="/google-ads/tools" element={<GoogleAdsToolsManager />} />
        {/* Old one-per-view URLs now land on the matching tab. */}
        <Route path="/google-ads/ad-groups" element={<Navigate to="/google-ads/campaigns?tab=ad-groups" replace />} />
        <Route path="/google-ads/reporting" element={<Navigate to="/google-ads/tools?tab=reporting" replace />} />
        <Route path="/google-ads/audiences" element={<Navigate to="/google-ads/tools?tab=audiences" replace />} />
        <Route path="/google-ads/lead-forms" element={<Navigate to="/google-ads/tools?tab=lead-forms" replace />} />
        {/* YouTube Ads workspace */}
        <Route path="/google-ads/youtube" element={<YouTubeAdsPage />} />
        <Route path="/google-ads/youtube/callback" element={<YouTubeCallback />} />
        <Route path="/google-ads/youtube/create" element={<YouTubeObjectivePicker />} />
        <Route path="/google-ads/youtube/create/campaign" element={<YouTubeCampaignWizard />} />
        {/* The single-card campaign form is retired — every campaign path goes through the wizard. */}
        <Route path="/google-ads/youtube/create/simple" element={<Navigate to="/google-ads/youtube/create/campaign?objective=youtube" replace />} />
        <Route path="/google-ads/youtube/create/adgroup" element={<CreateYouTubeAdgroup />} />
        <Route path="/google-ads/youtube/create/ad" element={<CreateYouTubeAd />} />
        {/* App Promotion (Google App campaigns) */}
        <Route path="/google-ads/app-promotion" element={<AppPromotionPage />} />
        <Route path="/google-ads/app-promotion/create" element={<AppPromotionWizard />} />
        {/* Objective workspaces — Leads / Website traffic (Search) */}
        <Route path="/google-ads/leads" element={<LeadsPage />} />
        <Route path="/google-ads/leads/create/campaign" element={<LeadsCampaignWizard />} />
        <Route path="/google-ads/leads/create/adgroup" element={<CreateLeadsAdgroup />} />
        <Route path="/google-ads/leads/create/ad" element={<CreateLeadsAd />} />
        <Route path="/google-ads/traffic" element={<TrafficPage />} />
        <Route path="/google-ads/traffic/create/campaign" element={<TrafficCampaignWizard />} />
        <Route path="/google-ads/traffic/create/adgroup" element={<CreateTrafficAdgroup />} />
        <Route path="/google-ads/traffic/create/ad" element={<CreateTrafficAd />} />
        {/* Awareness & reach (Display) */}
        <Route path="/google-ads/awareness" element={<AwarenessPage />} />
        <Route path="/google-ads/awareness/create/campaign" element={<AwarenessCampaignWizard />} />
        <Route path="/google-ads/awareness/create/adgroup" element={<CreateAwarenessAdgroup />} />
        <Route path="/google-ads/awareness/create/ad" element={<CreateAwarenessAd />} />
        {/* Sales / Local store visits (Performance Max — asset groups instead of ad groups + ads) */}
        <Route path="/google-ads/sales" element={<SalesPage />} />
        <Route path="/google-ads/sales/create/campaign" element={<SalesCampaignWizard />} />
        <Route path="/google-ads/sales/create/assetgroup" element={<CreateSalesAssetGroup />} />
        <Route path="/google-ads/local" element={<LocalPage />} />
        <Route path="/google-ads/local/create/campaign" element={<LocalCampaignWizard />} />
        <Route path="/google-ads/local/create/assetgroup" element={<CreateLocalAssetGroup />} />
        {/* Product sales (Shopping) */}
        <Route path="/google-ads/shopping" element={<ShoppingPage />} />
        <Route path="/google-ads/shopping/create/campaign" element={<ShoppingCampaignWizard />} />
        <Route path="/google-ads/shopping/create/adgroup" element={<CreateShoppingAdgroup />} />
        <Route path="/google-ads/shopping/create/ad" element={<CreateShoppingAd />} />
        <Route path="/deals" element={<DealsPage />} />
        {/* Industry pages — shown only where the company's blueprint turns them on. */}
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/new" element={<OrderComposer />} />
        <Route path="/orders/:orderUid" element={<OrdersPage />} />
        <Route path="/orders/:orderUid/edit" element={<OrderComposer />} />
        <Route path="/tables" element={<TablesPage />} />
        <Route path="/staff" element={<StaffShifts />} />
        <Route path="/stock" element={<StockPage />} />
        <Route path="/tickets" element={<TicketsList />} />
        <Route path="/tickets/:ticketUid" element={<TicketDetail />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:projectUid" element={<ProjectDetail />} />
        <Route path="/retainers" element={<RetainersPage />} />
        <Route path="/properties" element={<PropertiesPage />} />
        <Route path="/properties/:propertyUid" element={<PropertyDetail />} />
        <Route path="/viewings" element={<ViewingsPage />} />
        <Route path="/leases" element={<LeasesPage />} />
        <Route path="/owners" element={<OwnersTenantsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        {/* Custom Objects (per-business data) */}
        <Route path="/custom-objects" element={<CustomObjectTypesList />} />
        <Route path="/custom-objects/examples" element={<CustomObjectExamples />} />
        <Route path="/email-sequences" element={<EmailSequences />} />
        <Route path="/contacts/duplicates" element={<ContactDuplicates />} />
        {/* Appointments (booking module) */}
        <Route path="/appointments" element={<AppointmentCalendar />} />
        <Route path="/appointments/services" element={<ApptServicesPage />} />
        <Route path="/appointments/services/new" element={<ServiceEditorPage />} />
        <Route path="/appointments/services/:serviceUid/edit" element={<ServiceEditorPage />} />
        <Route path="/appointments/services/:serviceUid" element={<ServiceViewPage />} />
        <Route path="/appointments/bookings" element={<ApptBookingsPage />} />
        {/* Legacy booking-pages settings — replaced by the Appointments module. */}
        <Route path="/settings/booking" element={<Navigate to="/appointments/services" replace />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:productUid" element={<ProductDetailPage />} />
        <Route path="/custom-objects/types/new" element={<CustomObjectTypeEditor />} />
        <Route path="/custom-objects/types/:key" element={<CustomObjectTypeEditor />} />
        <Route path="/custom-objects/:typeKey" element={<CustomObjectRecordsList />} />
        <Route path="/custom-objects/:typeKey/new" element={<CustomObjectRecordEditor />} />
        <Route path="/custom-objects/:typeKey/:recordUid" element={<CustomObjectRecordEditor />} />

        <Route path="/ai-studio" element={<AiStudio />} />
        <Route path="/media-library" element={<MediaLibrary />} />
        <Route path="/whatsapp" element={<WhatsappOverview />} />
        <Route path="/whatsapp/catalog" element={<WhatsappCatalog />} />
        <Route path="/whatsapp/ads" element={<WhatsappStatusAds />} />
        <Route path="/whatsapp-accounts" element={<WhatsappAccountsManager />} />
        {/* Merged into the tabbed Accounts manager — keep old links working.
            Exact match only, so /whatsapp-account/bulk etc. still resolve. */}
        <Route path="/whatsapp-account" element={<Navigate to="/whatsapp-accounts?tab=profile" replace />} />
        <Route path="/whatsapp-account/bulk" element={<BroadcastsList />} />
        <Route path="/whatsapp-account/bulk/new" element={<BroadcastComposerRoute />} />
        <Route path="/whatsapp-account/bulk/:broadcastUid" element={<BroadcastDetail />} />
        {/* Merged into the tabbed Tools page — old links still resolve. */}
        <Route path="/whatsapp-account/tools" element={<WhatsappToolsManager />} />
        <Route path="/whatsapp-account/opt-outs" element={<Navigate to="/whatsapp-account/tools?tab=opt-outs" replace />} />
        <Route path="/whatsapp-account/tools/check-number" element={<Navigate to="/whatsapp-account/tools?tab=check-number" replace />} />
        <Route path="/whatsapp-account/audit" element={<Navigate to="/whatsapp-account/tools?tab=audit" replace />} />
        <Route path="/settings" element={<SettingsShell />}>
          <Route index element={<SettingsHub />} />
          <Route path="profile" element={<ProfileSettings />} />
          <Route path="team" element={<TeamSettings />} />
          <Route path="departments" element={<DepartmentsSettings />} />
          <Route path="ai" element={<AiSettings />} />
          <Route path="ai/languages" element={<AiSettings section="languages" />} />
          <Route path="ai/whatsapp" element={<AiSettings section="whatsapp" />} />
          <Route path="ai/usage" element={<AiSettings section="usage" />} />
          <Route path="industry" element={<IndustryPagesSettings />} />
          <Route path="developer" element={<DeveloperSettings />} />
          <Route path="plan" element={<PlanSettings />} />
          <Route path="integrations" element={<IntegrationsSettings />} />
          <Route path="crm-sync" element={<CrmSyncSettings />} />
          <Route path="business-profile" element={<BusinessProfileSettings />} />
          <Route path="localization" element={<LocalizationSettings />} />
          <Route path="lead-ad-forms" element={<LeadAdFormsSettings />} />
          <Route path="email-inboxes" element={<EmailInboxesSettings />} />
          <Route path="custom-fields" element={<CustomFieldsSettings />} />
          <Route path="pipelines" element={<PipelinesSettings />} />
          <Route path="booking-site" element={<BookingSiteSettings />} />
          <Route path="activity" element={<ActivitySettings />} />
        </Route>
        <Route path="/templates" element={<TemplatesList />} />
        <Route path="/templates/new" element={<TemplateEditor />} />
        <Route path="/templates/:uid" element={<TemplateEditor />} />
        <Route path="/leads" element={<LeadsInbox />} />
        <Route path="/leads/analytics" element={<LeadsAnalytics />} />
        <Route path="/leads/ai-analytics" element={<AiAnalytics />} />
        <Route path="/leads/ai-review" element={<AiConversationReview />} />
        <Route path="/leads/bot-flows" element={<BotFlowsList />} />
        <Route path="/leads/bot-flows/wizard" element={<BotFlowWizard />} />
        <Route path="/leads/bot-flows/:flowUid" element={<BotFlowDetail />} />
        <Route path="/leads/web-forms" element={<WebFormsList />} />
        <Route path="/leads/web-forms/new" element={<WebFormBuilder />} />
        <Route path="/leads/web-forms/:formUid" element={<WebFormBuilder />} />
        <Route path="/leads/:leadUid" element={<LeadDetail />} />
        <Route path="/campaigns" element={<CampaignsList />} />
        <Route path="/campaigns/new" element={<CampaignBuilder />} />
        <Route path="/campaigns/:uid" element={<CampaignDetail />} />
        {/* Merged into the tabbed Accounts manager — keep the old link working. */}
        <Route path="/facebook/ad-account" element={<Navigate to="/facebook/accounts?tab=settings" replace />} />
        <Route path="/facebook/accounts" element={<FacebookAccountsManager />} />
        <Route path="/facebook/campaigns" element={<FacebookCampaignsList />} />
        <Route path="/facebook/campaigns/new" element={<CampaignBuilderRoute />} />
        <Route path="/facebook/campaigns/:campaignId" element={<FacebookCampaignDetail />} />
        <Route path="/facebook/campaigns/:campaignId/ad-sets/new" element={<AdSetBuilderRoute />} />
        <Route path="/facebook/ad-sets/:adSetId" element={<AdSetDetail />} />
        <Route path="/facebook/ad-sets/:adSetId/ads/new" element={<AdBuilderRoute />} />
        <Route path="/facebook/creatives" element={<CreativesList />} />
        <Route path="/facebook/creatives/new" element={<CreativeBuilderRoute />} />
        <Route path="/facebook/ai-campaign" element={<AiCampaignWizard />} />
        <Route path="/facebook/audiences" element={<AudiencesList />} />
        <Route path="/facebook/lead-forms" element={<LeadFormsList />} />
        <Route path="/facebook/lead-forms/new" element={<LeadFormBuilder />} />
        <Route path="/facebook/lead-forms/:formId" element={<LeadFormDetail />} />
        <Route path="/facebook/page" element={<FacebookPageManager />} />
        {/* Instagram is now a top-level module (matches TikTok/WhatsApp structure).
            Old /facebook/instagram* URLs redirect to /instagram* so any bookmarks,
            saved-toast deep-links, or 3rd-party integrations keep working.
            The full IG campaign builder is the workspace at /instagram/workspace —
            same machinery as /facebook/workspace, locked to Instagram-only
            placements + forced IG actor on every ad. The legacy three-step
            wizard at /instagram/campaign/new is gone — it had no creative
            step and no country dropdown; the workspace handles both. */}
        <Route path="/instagram" element={<InstagramOverview />} />
        {/* /instagram/posts is the listing; the composer sits under it. */}
        <Route path="/instagram/posts" element={<InstagramPosts />} />
        <Route path="/instagram/posts/new" element={<InstagramPublish />} />
        <Route path="/instagram/publish" element={<InstagramPublish />} />
        <Route path="/instagram/workspace" element={<IgWorkspace />} />
        <Route path="/instagram/workspace/:draftId" element={<IgWorkspace />} />
        <Route path="/instagram/campaigns" element={<InstagramCampaignsList />} />
        <Route path="/instagram/campaign/new" element={<Navigate to="/instagram/workspace" replace />} />
        <Route path="/facebook/instagram" element={<Navigate to="/instagram" replace />} />
        <Route path="/facebook/instagram/publish" element={<Navigate to="/instagram/posts/new" replace />} />
        <Route path="/facebook/instagram/campaign/new" element={<Navigate to="/instagram/workspace" replace />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
